import type { HTMLAttributes, ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "../helpers/class-names";
import { ActionIcon } from "./ActionIcon";

type ModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description: string;
  children: ReactNode;
  className?: string;
  headerAccessory?: ReactNode;
};

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  className,
  headerAccessory,
}: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="ui-modal-overlay" />
        <Dialog.Content className={cn("ui-modal", className)}>
          <div className="ui-modal-header">
            <div>
              <Dialog.Title>{title}</Dialog.Title>
              <Dialog.Description>{description}</Dialog.Description>
            </div>
            <div className="ui-modal-header-actions">
              {headerAccessory}
              <Dialog.Close asChild>
                <ActionIcon icon={<X />} label="Close" size="small" />
              </Dialog.Close>
            </div>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export function ModalFooter({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("ui-modal-footer", className)} {...props} />;
}
